import { render } from "./AboutUsPage.vue?vue&type=template&id=307d3374&scoped=true&ts=true"
import script from "./AboutUsPage.vue?vue&type=script&lang=ts"
export * from "./AboutUsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/moneyspace/moneyspace_homepage_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307d3374"]])

export default __exports__